module.exports = __webpack_public_path__ + "media/images/emblems/Werthenstein_LU-2743a7a8afea27712f9f43d7eeda810b.png";